/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Channel_AgencyInputs */

const en_price_channel_agency = /** @type {(inputs: Price_Channel_AgencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agency`)
};

/**
* | output |
* | --- |
* | "Agency" |
*
* @param {Price_Channel_AgencyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const price_channel_agency = /** @type {((inputs?: Price_Channel_AgencyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Channel_AgencyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_price_channel_agency(inputs)
});